// extracted by mini-css-extract-plugin
export var centered = "metadata-module--centered--d955b";
export var grey = "metadata-module--grey--faf3c";
export var icon = "metadata-module--icon--220d3";
export var item = "metadata-module--item--52a74";
export var white = "metadata-module--white--ffe01";
export var wrapper = "metadata-module--wrapper--b3cae";